import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import style from './default-placeholder.module.css';

export const DefaultPlaceholder = () => {
  return (
    <div className={style['default-placeholder']}>
      <div className={style['placeholder-content']}>
        <div>
          <FontAwesomeIcon className={style['placeholder-icon']} icon={faExclamationTriangle} />
        </div>
        <div className={style['placeholder-message']}>
          <FormattedMessage
            defaultMessage='No data in the grid. Try something else!'
            description='defaultPlaceholder.noDataInHooksGrid'
            id='qS3tUS'
          />
        </div>
      </div>
    </div>
  );
};
